import useScrollReveal from '@/hooks/useScrollReveal';
import SectionHeading from '@/components/feature/SectionHeading';

export default function AboutSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.15 });

  return (
    <section id="o-nas" className="relative py-16 md:py-24 px-4 md:px-6 bg-background-50 scroll-mt-16 md:scroll-mt-20" ref={ref}>
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 md:gap-16">
          {/* Image Side */}
          <div
            className={`w-full lg:w-1/2 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
            }`}
          >
            <div className="relative">
              <div className="w-full h-[340px] md:h-[420px] rounded-lg overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/a8aec268cac0192721b3d5189e84d7be.png"
                  alt="Prostorna notranjost lokala Guma Caffe Lounge Bar Gorišnica s sedeži in osvetlitvijo"
                  title="Notranjost Guma Caffe Lounge Bar v Zamušanih"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              {/* Award floating card */}
              <div className="absolute -bottom-5 right-2 md:-right-6 md:-bottom-6 bg-accent-500 text-foreground-50 rounded-lg px-4 py-3.5 md:px-5 md:py-4 max-w-[190px] md:max-w-[200px]">
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-trophy-line text-xl"></i>
                </div>
                <p className="mt-1 text-xs font-semibold leading-snug">Naj kava po izboru bralcev Ptujinfo 2024</p>
                <p className="mt-0.5 text-[10px] text-foreground-50/70">1. mesto v regiji</p>
              </div>
            </div>
          </div>

          {/* Text Side */}
          <div
            className={`w-full lg:w-1/2 transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
            }`}
          >
            <SectionHeading
              align="left"
              className=""
              eyebrow="O Guma Baru"
              title={<>Kjer se <span className="text-primary-400">odlična kava</span> sreča s prijetno družbo</>}
            />
            <p className="mt-5 text-foreground-300 leading-relaxed text-sm md:text-base">
              Guma Bar je priljubljeno stičišče domačinov in obiskovalcev Zamušanov — prostor za sproščene trenutke ob skodelici vrhunske kave.
            </p>
            <p className="mt-3 text-foreground-300 leading-relaxed text-sm md:text-base">
              Nahajamo se ob glavni cesti, v bližini servisne delavnice — priročno za hitro kavo med čakanjem. Leta 2024 smo prejeli priznanje <strong className="text-foreground-100">Naj kava po izboru bralcev Ptujinfo</strong>.
            </p>

            <div className="flex flex-wrap gap-6 mt-7">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-cup-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">Nagrajena</p>
                  <p className="text-sm font-semibold text-foreground-100">Kava</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-sun-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">Odlična</p>
                  <p className="text-sm font-semibold text-foreground-100">Terasa</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-emotion-happy-line text-secondary-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">Prijazno</p>
                  <p className="text-sm font-semibold text-foreground-100">Osebje</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}